// pages/ExpensesPage.jsx
import React, { useEffect, useState } from 'react';
import SidebarMenu from "../components/SidebarMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { formatCurrencyTRY, formatDateTimeTR } from '../utils/filter_lib';
import api from "../services/api";
import ExpenseFormModal from "../components/ExpenseFormModal";
import ImagePreviewModal from "../components/ImagePreviewModal";
import { toast } from 'react-toastify';

function ExpensesPage() {
  const [expenses, setExpenses] = useState([]);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchExpenses = async () => {
    const res = await api.get("/expenses/mines");
    setExpenses(res.data);
  };

  const fetchExpenseTypes = async () => {
    try {
      const res = await api.get("/expenses/types");
      setExpenseTypes(res.data.map(et => ({ label: et.name, value: et.id })));
    } catch (e) {
      console.error("Harcama tipi listelenemedi:", e);
    }
  };

  useEffect(() => {
    fetchExpenses();
    fetchExpenseTypes();
  }, []);

  const handleSubmit = async (data) => {
    const formData = new FormData();
    formData.append('amount', data.amount);
    formData.append('reason', data.reason);
    formData.append('expense_date', data.expense_date.toISOString());
    formData.append('expense_type_id', data.expense_type_id);
    formData.append('file', data.doc_file);

    try {
      await api.post("/expenses", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setAddModalVisible(false);
      fetchExpenses();
    } catch (error) {
      if (error?.response?.status === 422) {
        throw error;
      }
      const message = error.response?.data?.detail || 'Harcama eklenemedi.';
      toast.error(message);
    }
  };

  const buildDocumentUrl = (docPath) => {
    if (!docPath) {
      return null;
    }

    if (/^https?:\/\//i.test(docPath)) {
      return docPath;
    }

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    if (!baseURL) {
      return docPath.startsWith('/') ? docPath : `/${docPath}`;
    }

    const normalizedBase = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
    const normalizedPath = docPath.startsWith('/') ? docPath : `/${docPath}`;

    return `${normalizedBase}${normalizedPath}`;
  };

  const handleRowClick = (e) => {
    const documentUrl = buildDocumentUrl(e.data.doc_path);

    if (documentUrl) {
      setSelectedImage(documentUrl);
      setImageModalVisible(true);
    }
  };

  const formatExpenseAmount = (value) => {
    const formatted = formatCurrencyTRY(value);
    return formatted || '-';
  };

  const header = (
    <div className="flex justify-between align-items-center">
      <h3>Harcama Listesi</h3>
      <Button label="Harcama Ekle" icon="pi pi-plus" onClick={() => setAddModalVisible(true)} />
    </div>
  );

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <DataTable
          value={expenses}
          header={header}
          paginator
          rows={20}
          stripedRows
          filterDisplay="row"
          onRowClick={handleRowClick}
        >
          <Column body={(rowData) => formatDateTimeTR(rowData.expense_date)} header="Tarih" />
          <Column field="expense_type.name" header="Tip" />
          <Column body={(rowData) => formatDateTimeTR(rowData.log_date)} header="Kayıt Tarihi" />
          <Column field="manager_notes" header="Red Sebebi" />
          <Column body={(rowData) => formatExpenseAmount(rowData.amount)} header="Tutar" />
          <Column field="status" header="Durum" />
        </DataTable>

        <ExpenseFormModal
          visible={addModalVisible}
          onHide={() => setAddModalVisible(false)}
          expenseTypes={expenseTypes}
          onSubmit={handleSubmit}
        />

        <ImagePreviewModal
          visible={imageModalVisible}
          onHide={() => setImageModalVisible(false)}
          imageUrl={selectedImage}
        />
      </main>
    </div>
  );
}

export default ExpensesPage;
